<template lang="pug">
    .page
        .content-container
            .title {{detail.title}}
            .time {{detail.created_at}}
            .content(v-html="detail.content")
</template>

<script>
import axios from 'axios'

export default {
    name: 'NewsDetail',
    data() {
        return {
            detail: {
                created_at: '',
                title: '',
                introduction: '',
                content: ''
            }
        }
    },
    computed: {
        id() {
            return this.$route.params.id
        }
    },
    methods: {
        onGetDetail() {
            axios.get(`/api/article/${this.id}`).then(res => {
                this.detail = res.data
            })
        }
    },
    created() {
        this.onGetDetail()
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    background: #f9f9f9
    padding-top: 20px
    .banner
        width: 100%
    .content-container
        max-width: 1000px
        margin: 0 auto
        padding: 60px 10%
        .title
            font-size: 1.2rem
        .time
            font-size: 12px
            margin: 1em 0
        .news-item
            cursor: pointer
            background: #fff
            margin-bottom: 30px
            transition: all 1s
            padding: 20px
            &:hover
                box-shadow: 0 5px 5px 0px #eee
            img
                background: #eee
                display: block
                width: 100%
            .content
                padding: 30px
    .more-btn
        cursor: pointer
        text-align: center
        font-size: 14px
        color: #c40000
        height: 100px
        background: #fff
        padding-top: 20px
        box-sizing: border-box
@media screen and (min-width: 1024px)
    .page
        width: 100%
        background: #f9f9f9
        padding-top: 100px
        .banner
            width: 100%
        .content-container
            max-width: 1000px
            margin: 0 auto
            min-height: 1030px
            padding-top: 60px
            .news-item
                cursor: pointer
                background: #fff
                display: flex
                margin-bottom: 30px
                transition: all 1s
                &:hover
                    box-shadow: 0 5px 5px 0px #eee
                img
                    background: #eee
                    display: block
                    width: 50%
                .content
                    padding: 30px
        .more-btn
            cursor: pointer
            text-align: center
            font-size: 14px
            color: #c40000
            height: 100px
            background: #fff
            padding-top: 20px
            box-sizing: border-box
</style>